// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1ojQv","row":"Node_row__1m0xS","label":"Node_label__3kkQr","footer":"Node_footer__2d5bg"};